import {
  getDiscountCoupons,
  deleteDiscountCoupon,
  registerDiscountCoupon,
  updateDiscountCoupon,
  getCouponById,
} from "../../api";
import { i18n } from "../../main";
import router from "../../router";

const state = {
  discountCoupons: [],
  couponData: {},
  isLoadingCoupons: false,
  isLoadingCouponDetails: "",
};

const getters = {
  discountCoupons: state => state.discountCoupons,
  couponData: state => state.couponData,
  isLoadingCoupons: state => state.isLoadingCoupons,
  isLoadingCouponDetails: state => state.isLoadingCouponDetails,
};

const actions = {
  async fetchDiscountCoupons(
    { commit, dispatch },
    { store, couponCode, initialDate, finalDate }
  ) {
    commit("setIsLoadingCoupons", true);
    try {
      const response = await getDiscountCoupons(
        store,
        couponCode,
        initialDate,
        finalDate
      );
      commit("setDiscountCoupons", response.data);
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    } finally {
      commit("setIsLoadingCoupons", false);
    }
  },
  async getCouponById({ commit, dispatch }, couponId) {
    commit("setIsLoadingCouponDetails", couponId);

    try {
      const response = await getCouponById(couponId);
      commit("setCouponData", {
        couponCode: response.data.codigo,
        status: response.data.status === "ATIVO" ? "active" : "inactive",
        productNId: response.data.nidproduto,
        productVariationNId: response.data.nidprod_variacao,
        store: response.data.loja,
        marketplaceCoupon: response.data.loja == null ? "active" : "inactive",
        initDateTime: response.data.dthr_validade_ini,
        finalDateTime: response.data.dthr_validade_fim,
        quantity: response.data.quantidade,
        useLimit: response.data.limite_uso,
        documents: response.data.documentos,
        discountType:
          Number(response.data.valor_desconto) > 0 ? "value" : "percentage",
        discountValue: response.data.valor_desconto,
        discountPercentage: response.data.perc_desconto,
        maxDiscount: response.data.valor_max_desconto,
        minOrderValue: response.data.valor_min_pedido,
        membershipToken: response.data.token_socio,
        membershipUrl: response.data.url_socio,
        couponId: couponId,
      });
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    } finally {
      commit("setIsLoadingCouponDetails", "");
    }
  },
  async registerDiscountCoupon({ dispatch }, coupon) {
    try {
      await registerDiscountCoupon(coupon);
      dispatch(
        "showSnackbarSuccess",
        i18n.t("sales.discount-coupon.register-success")
      );
      router.push({ name: "discountCoupon" });
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    }
  },
  async updateDiscountCoupon({ dispatch }, coupon) {
    try {
      await updateDiscountCoupon(coupon);
      dispatch(
        "showSnackbarSuccess",
        i18n.t("sales.discount-coupon.update-success")
      );
      router.push({ name: "discountCoupon" });
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    }
  },
  async handleDiscountCoupon({ dispatch, getters }, type) {
    const coupon = {
      codigo: getters.couponData.couponCode,
      status: getters.couponData.status === "active" ? "ATIVO" : "INATIVO",
      nidproduto: getters.couponData.productNId,
      nidprod_variacao: getters.couponData.productVariationNId,
      loja:
        getters.couponData.marketplaceCoupon === "active"
          ? null
          : getters.storeSequencial,
      dthr_validade_ini: getters.couponData.initDateTime,
      dthr_validade_fim: getters.couponData.finalDateTime,
      quantidade: getters.couponData.quantity,
      limite_uso: getters.couponData.useLimit,
      documentos: getters.couponData.documents,
      valor_desconto: getters.couponData.discountValue,
      perc_desconto: getters.couponData.discountPercentage,
      valor_max_desconto: getters.couponData.maxDiscount,
      valor_min_pedido: getters.couponData.minOrderValue,
      token_socio: getters.couponData.membershipToken,
      url_socio: getters.couponData.membershipUrl,
    };

    if (type === "register") {
      await dispatch("registerDiscountCoupon", coupon);
    } else if (type === "update") {
      await dispatch("updateDiscountCoupon", {
        ...coupon,
        idcupom: getters.couponData.couponId,
      });
    }
  },
  async deleteDiscountCoupon({ dispatch }, { couponId, store }) {
    try {
      await deleteDiscountCoupon(couponId);
      dispatch(
        "showSnackbarSuccess",
        i18n.t("sales.discount-coupon.delete-success")
      );
      dispatch("fetchDiscountCoupons", { store });
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    }
  },
};

const mutations = {
  setDiscountCoupons: (state, discountCoupons) =>
    (state.discountCoupons = discountCoupons),
  setCouponData: (state, couponData) => (state.couponData = couponData),
  setIsLoadingCoupons: (state, isLoadingCoupons) =>
    (state.isLoadingCoupons = isLoadingCoupons),
  setIsLoadingCouponDetails: (state, isLoadingCouponDetails) =>
    (state.isLoadingCouponDetails = isLoadingCouponDetails),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
